import React, { useEffect, useState } from "react";

import basketContext from "./BasketContext";
import axios from "axios";
import { initialValues } from "../components/organisms/forms/FormAddress/initialValues";

const BasketContextProvider = ({ children }) => {
  const [basketId, setBasketId] = useState("");
  const [basketCount, setBasketCount] = useState("");
  const [summary, setSummary] = useState(null);
  const [basket, setBasket] = useState(null);
  const [address, setAddress] = useState(initialValues);
  const [userCountry, setUserCountry] = useState({
    code: "PL",
    name: "Poland",
  });
  const [options, setOptions] = useState();

  useEffect(() => {
    const allowedCountries = ["PL", "AU", "MX"];
    axios
      .get("https://api.ozparts.eu/country")
      .then((res) => {
        setUserCountry({
          code: res.data.code,
          name: res.data.country,
        });
        // if (!allowedCountries.includes(res.data.code)) {
        //   window.location.href = "https://pedders.eu";
        // }
      })
      .catch(() => {
        setUserCountry({
          code: "PL",
          name: "Poland",
        });
      });
  }, []);

  const reset = () => {
    setBasketCount("");
    setBasketId("");
    setBasket(null);
    setSummary(null);
    setAddress(initialValues);
    setOptions(null);
  };

  const value = {
    basketId,
    setBasketId,
    basketCount,
    setBasketCount,
    summary,
    setSummary,
    basket,
    setBasket,
    address,
    setAddress,
    reset,
    userCountry,
    options,
    setOptions,
  };

  return (
    <basketContext.Provider value={value}>{children}</basketContext.Provider>
  );
};

export default BasketContextProvider;
